import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ISmartChargingAccount } from "./smartChargingAccount.types"
import { GetSmartChargingAccountsQuery } from "@/api/hasura/generated/graphql"
import { dayjsOrNull } from "@/helpers/dateHelper"

export type SmartChargingAccountRaw =
  GetSmartChargingAccountsQuery["smart_charging"][number]

export const SmartChargingAccountParser: IParser<
  ISmartChargingAccount,
  SmartChargingAccountRaw
> = {
  toDomain: (data: SmartChargingAccountRaw): ISmartChargingAccount => {
    try {
      return {
        id: Number(data.id),
        billingAccountId: Number(data.billing_account_id),
        axleSiteId: data.axle_site_id ?? null,
        meterPointId:
          data.meter_point_id === null || data.meter_point_id === undefined
            ? null
            : Number(data.meter_point_id),
        onboardedAt: dayjsOrNull(data.onboarded_at),
        offboardedAt: dayjsOrNull(data.offboarded_at),
        createdAt: dayjsOrNull(data.created_at),
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
